export const MODE_PLAY = 'play'
export const MODE_REPLAY = 'replay'
